import React from "react";

import { isNonEmptyObject, isEmptyObject } from "_helpers";

import { Button, Form, Space } from "antd";

import dayjs from 'dayjs';

export const RemoteLicensesActionsCell = ({ 
    rec,
    isDisabled,
    editIsPending,
    tableData,
    onCancelRow,
    setEditModeKey,
    setValues
 }) => {
    const form = Form.useFormInstance();

    const findRecursive = ( array, key ) => {
        for( const el of array ) {
            if( el.key === key ) {
                return el;
            }
            if( el.children && el.children.length > 0 ) {
                const found = findRecursive(el.children, key);
                if( found ) return found;
            }
        }
        return null;
    }

    const handleEditRow = ( ) => {
        form.setFieldsValue({ 
            ...rec, 
            date_activation: rec.date_activation && rec.date_activation !== '0000-00-00' ? dayjs(rec.date_activation) : null,
            date_deactivation: rec.date_deactivation && rec.date_deactivation !== '0000-00-00' ? dayjs(rec.date_deactivation) : null
        });
        setEditModeKey(rec.key);
    }

    const handleCancelRow = ( ) => {
        form.resetFields();
        onCancelRow();
    }

    const handleSubmitRow = async ( method ) => {
        let values = {
            ...rec,
            ...form.getFieldsValue()
        };
       
        const key = values.key;
        if( key === 'new' ) method = 'add';

        let newValues = {};
        if( ["add", "edit"].includes(method) ){
            try{
                let row = await form.validateFields();
                if( method === 'add' ){
                    if( values?.['parent'] && values?.['parent'] !== values?.['base'] ){
                        form.setFields([
                            {
                                name: 'base',
                                errors: ['Doit correspondre à Enfant de'],
                            }, {
                                name: 'parent',
                                errors: ['Doit correspondre à Base'],
                            },
                        ]);
                        return;
                    }
                } else if( method === 'edit' ){
                    newValues = {
                        ...values,
                        date_activation: row.date_activation ? dayjs(row.date_activation).format("YYYY-MM-DD") : null,
                        date_deactivation: row.date_deactivation ? dayjs(row.date_deactivation).format("YYYY-MM-DD") : null
                    };
                }
            } catch(err){
                console.log(err);
                return ;
            }
        }

        if( isNonEmptyObject(newValues) ) values = newValues;

        if( ["edit", "disable", "reactivate"].includes(method) ){
            const find = findRecursive(tableData, key);
            if( find ){
                setValues(values, method);
            }
        } else if( method === 'add' ){
            setValues(values, method);
        }
        handleCancelRow();
    }

    return(
        <Space>
            {
                isDisabled && !editIsPending
                ?
                    <>
                        <Button
                            type="primary"
                            onClick={handleEditRow}
                        >
                            Editer
                        </Button>
                        <Button 
                            type="primary"
                            danger
                            onClick={() => handleSubmitRow('reactivate')}
                        >
                            Réactiver
                        </Button>
                    </>
                :
                editIsPending 
                ?
                    <>
                        <Button
                            color="green"
                            variant="solid"
                            onClick={() => handleSubmitRow('edit')}
                        >
                            Sauver
                        </Button>
                        <Button
                            color="orange"
                            variant="solid"
                            onClick={handleCancelRow}
                        >
                            Annuler
                        </Button>
                    </>
                : 
                    <>
                        <Button
                            type="primary"
                            onClick={handleEditRow}
                        >
                            Editer
                        </Button>
                        <Button
                            type="primary"
                            danger
                            onClick={() => handleSubmitRow('disable')}
                        >
                            Désactiver
                        </Button>
                    </>
            }
        </Space>
    );
}